module.exports = __webpack_public_path__ + "img/icon-files.b4661730.png";